export default __webpack_public_path__ + "static/media/Toplu_Jandarma_Cikis_Bildirimi.259432fe.xlsx";